import { IUserLogInRequestModel } from './../interfaces/requests/IUserLogInRequestModel';
import { authInstance, guestInstance } from ".";
import { IUserSignUpRequestModel } from "../interfaces/requests/IUserSignUpRequestModel";
import { IUserResponseModel } from "../interfaces/responses/IUserResponseModel";
import { IUserUpdate } from '../interfaces/responses/IUserUpdate';

export const signup = async (
    userData: IUserSignUpRequestModel
): Promise<{ error: string, message: string } | null> => {
    try {
        await guestInstance.post('user/signup', { ...userData });
        return null;
    } catch (e: any) {
        return e.response.data || ['Возникла ошибка при попытке регистрации'];
    }
};

export const login = async (
    userData: IUserLogInRequestModel
): Promise<IUserResponseModel | string[]> => {
    try {
        const response = await guestInstance.post('user/login', { ...userData });
        const user: IUserResponseModel = response.data;
        
        if (!user.token) {
            throw new Error('Token is missing from the response');
        }
        
        localStorage.setItem('token', user.token);
        
        console.log(user)
        return user;
    } catch (e: any) {
        if (e.response && e.response.data && e.response.data.message) {
            return [e.response.data.message];
        }
        return ['Возникла непредвиденная ошибка. Попробуйте позже.'];
    }
};


export const verifyEmail = async (token: string): Promise<string | string[]> => {
    try {
        const response = await guestInstance.get('/user/verify-email', {
            params: { token }
        });
        return response.data.message;
    } catch (e: any) {
        return e.response?.data?.errors || ['Ошибка подтверждения email'];
    }
};

export const checkToken = async (): Promise<IUserResponseModel | null> => {
    const token = localStorage.getItem('token');

    if (!token) {
        return null;
    }

    const isTokenExpiringSoon = (token: string): boolean => {
        const decoded = JSON.parse(atob(token.split('.')[1]));
        const expirationTime = decoded.exp * 1000;
        const timeLeft = expirationTime - Date.now();
        return timeLeft < 10 * 60 * 1000;
    };

    if (!isTokenExpiringSoon(token)) {
        try {
            const response = await authInstance.get('user/check');
            const user: IUserResponseModel = {
                token: response.data.token,
                userId: response.data.userId,
                email: response.data.email,
                phone: response.data.phone || null,
                firstname: response.data.firstname || null,
                lastname: response.data.lastname || null,
                middlename: response.data.middlename || null,
                role: response.data.role,
                isEmailConfirmed: true
            };
            localStorage.setItem('token', user.token || '');

            return user;
        } catch (e: any) {
            console.error('Ошибка проверки токена', e);
            localStorage.removeItem('token');
            return null;
        }
    }

    return null;
};

export const getAllUsers = async (): Promise<IUserResponseModel[] | string> => {
    try {
        const response = await authInstance.get('user/getAll');
        return response.data;
    } catch (e: any) {
        return e.response?.data?.message || ['Ошибка получения пользователей'];
    }
};


export const updateUser = async (
    id: string,
    userData: Partial<IUserUpdate>
): Promise<IUserResponseModel | { error: string, message: string }> => {
    try {
        const response = await authInstance.put(`user/update/${id}`, { ...userData });
        return response.data;
    } catch (e: any) {
        return e.response?.data?.errors || ['Ошибка при обновлении данных пользователя'];
    }
};

export const deleteUser = async (id: string): Promise<string> => {
    try {
        await authInstance.delete(`user/delete/${id}`);
        return 'Пользователь успешно удален';
    } catch (e: any) {
        return e.response?.data?.message || ['Ошибка при удалении пользователя'];
    }
};

export const changePassword = async (
    userId: string,
    password: string,
    newPassword: string
): Promise<{ error?: string, message: string }> => {
    try {
        const response = await authInstance.put(`user/changePassword/${userId}`, { password, newPassword });
        return response.data;
    } catch (e: any) {
        return { error: e.response?.data?.error || 'Ошибка при изменении пароля', message: '' };
    }
};

export const resetPassword = async (
    email: string
): Promise<{ error?: string, message: string }> => {
    try {
        const response = await authInstance.put(`user/resetPassword`, { email });
        return response.data;
    } catch (e: any) {
        return { error: e.response?.data?.error || 'Ошибка при сбросе пароля', message: '' };
    }
};

export const logout = (): void => {
    localStorage.removeItem('token');
};